import AIModuleMarketingModal from "./AIModuleMarketingModal";
export { AI_MODULES_FOR_MARKETING } from "./AIModuleMarketingUtils";

export default AIModuleMarketingModal;
